import Api from './Api';

const all = (payload) => {
    const path = '/niche-categories';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const getAll = (payload) => {
    const path = '/niche-category/get-all';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/niche-categories/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: '/niche-categories/update',
        method: 'PUT',
        data: payload
    });
};
const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/niche-categories/destroy/${payload.id}`,
    });
};

const softDelete = (payload) => {
    return Api.deleteRequest({
        endpoint: `/niche-categories/soft-delete/${payload.id}`,
    });
};

export default {
    all,
    getAll,
    store,
    update,
    destroy,
    softDelete
};
